import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ClosedPage from './components/ClosedPage';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';

// The project has been closed due to lack of signups. Every route except the
// legal pages shows the closure notice, and nothing talks to the backend.
export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="*" element={<ClosedPage />} />
      </Routes>
    </BrowserRouter>
  );
}
